import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.hasOtherPages
    ? _c(
        "nav",
        {
          staticClass: "link-pagination",
          attrs: { role: "navigation", "aria-label": "Навигация по страницам" },
        },
        [
          _c(
            "ul",
            {
              staticClass:
                "link-pagination__list d-flex justify-center align-center mb-0 pa-0",
            },
            [
              _c("li", [
                _vm.hasPrevious && _vm.previousPageNumber
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "d-inline-flex align-center justify-center rounded-circle text-decoration-none text-body-1 text-secondary--text bg-gray-0 elevation-1 ml-1 mr-3",
                        attrs: {
                          href: _vm.getHref(_vm.previousPageNumber),
                          "aria-label": "Предыдущая страница",
                        },
                        on: {
                          click: function ($event) {
                            return _setup.onPageClick(
                              $event,
                              _vm.previousPageNumber
                            )
                          },
                        },
                      },
                      [
                        _c(
                          VIcon,
                          {
                            staticClass: "pa-2",
                            attrs: { "aria-hidden": "true", size: "16" },
                          },
                          [_vm._v("\n          ui-icon-arrow-left\n        ")]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      {
                        staticClass:
                          "d-inline-flex align-center justify-center rounded-circle text-body-1 disabled--text bg-gray-0 elevation-1 ml-1 mr-3",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          VIcon,
                          {
                            staticClass: "pa-2",
                            attrs: { "aria-hidden": "true", size: "16" },
                          },
                          [_vm._v("\n          ui-icon-arrow-left\n        ")]
                        ),
                      ],
                      1
                    ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.pageRange, function (pageNumber, index) {
                return _c("li", { key: `${pageNumber}-${index}` }, [
                  pageNumber === _vm.currentPage
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "link-pagination__item d-inline-flex align-center justify-center rounded-circle text-body-1 primary bg-gray-0--text elevation-2 mx-1",
                          attrs: {
                            "aria-current": "true",
                            "aria-label": `Текущая страница, Страница ${pageNumber}`,
                          },
                        },
                        [_vm._v("\n        " + _vm._s(pageNumber) + "\n      ")]
                      )
                    : !pageNumber
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "link-pagination__item d-inline-flex align-end justify-center text-body-1 text-secondary--text mx-1",
                        },
                        [_vm._v("\n        ...\n      ")]
                      )
                    : _c(
                        "a",
                        {
                          staticClass:
                            "link-pagination__item d-inline-flex align-center justify-center rounded-circle text-decoration-none text-body-1 text-secondary--text bg-gray-0 elevation-1 mx-1",
                          attrs: {
                            href: _vm.getHref(pageNumber),
                            "aria-label": `Страница ${pageNumber}`,
                          },
                          on: {
                            click: function ($event) {
                              return _setup.onPageClick($event, pageNumber)
                            },
                          },
                        },
                        [_vm._v("\n        " + _vm._s(pageNumber) + "\n      ")]
                      ),
                ])
              }),
              _vm._v(" "),
              _c("li", [
                _vm.hasNext && _vm.nextPageNumber
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "d-inline-flex align-center justify-center rounded-circle text-decoration-none text-body-1 text-secondary--text bg-gray-0 elevation-1 ml-3 mr-1",
                        attrs: {
                          href: _vm.getHref(_vm.nextPageNumber),
                          "aria-label": "Следующая страница",
                        },
                        on: {
                          click: function ($event) {
                            return _setup.onPageClick(
                              $event,
                              _vm.nextPageNumber
                            )
                          },
                        },
                      },
                      [
                        _c(
                          VIcon,
                          {
                            staticClass: "pa-2",
                            attrs: { "aria-hidden": "true", size: "16" },
                          },
                          [_vm._v("\n          ui-icon-arrow-right\n        ")]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "span",
                      {
                        staticClass:
                          "d-inline-flex align-center justify-center rounded-circle text-body-1 disabled--text bg-gray-0 elevation-1 ml-3 mr-1",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c(
                          VIcon,
                          {
                            staticClass: "pa-2",
                            attrs: { "aria-hidden": "true", size: "16" },
                          },
                          [_vm._v("\n          ui-icon-arrow-right\n        ")]
                        ),
                      ],
                      1
                    ),
              ]),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }